import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import moment from "moment";
import { useCatchResponse } from '../../../utils/useCatchResponse';


const CoScholasticGrading = () => {
    const { catchResponse } = useCatchResponse();
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [coScholasticOnGoingGradesList, setCoScholasticOnGoingGradesList] = useState([]);
    const [coScholasticCompletedGradesList, setCoScholasticCompletedGradesList] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };
    const filteredExams = (activeTab === 1 ? coScholasticCompletedGradesList : coScholasticOnGoingGradesList).filter(exam =>
        exam?.ClassName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        exam?.TermName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        exam?.CoScholasticName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        GetCoScholasticGradeList(loginData?._id, loginData?.CreatedBy);
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const dateBodyTemplate = (rows, type) => {
        return (
            <div>{moment(rows[type]).format("DD-MM-YYYY")}</div>
        );
    };

    const GetCoScholasticGradeList = async (id, schId) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schId
            }
            Loader.show();
            await api.post(APIConstant.path.GetCoScholasticGradesList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var onGoingList = res?.data.filter(x => x?.IsAllow === true);
                    var completeList = res?.data.filter(x => x?.IsAllow === false);
                    setCoScholasticOnGoingGradesList(onGoingList);
                    setCoScholasticCompletedGradesList(completeList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const actionTemplate = (rowData) => (
        <Button label={!rowData?.IsAllow ? "View" : "Grade"} onClick={(e) => navigate('/co-scholastic-entry', { state: { className: rowData?.ClassName, classId: rowData?.ClassId, coScholasticTemplateId: rowData?.CoScholasticTemplateId, isAllow: rowData?.IsAllow } })} />
    );

    const srNoBodyTemplate = (data, props) => {
        return props?.rowIndex + 1;
    };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-book"></i>
                    <h2>Co-Scholastic Grading</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <div className="e-tab-main">
                <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                    <TabPanel header="Ongoing">
                        <DataTable value={filteredExams} paginator
                            rows={rows}
                            first={first}
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            rowsPerPageOptions={[5, 10, 20]}
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            onPage={onPageChange}
                            className='custom-table'
                            scrollHeight='calc(100vh - 175px)'
                            size='small'
                        >
                            <Column header="Sr No" body={srNoBodyTemplate} />
                            <Column field="ClassName" header="Class" />
                            <Column field="TermName" header="Term Name" />
                            <Column field="CoScholasticName" header="Co-Scholastic Name" />
                            <Column field="StartDate" header="StartDate" body={(rowData) => dateBodyTemplate(rowData, 'StartDate')} />
                            <Column field="EndDate" header="End Date" body={(rowData) => dateBodyTemplate(rowData, 'EndDate')} />
                            <Column header='Action' body={actionTemplate} headerStyle={{ display: 'flex', justifyContent: 'end' }} />
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Completed">
                        <DataTable value={filteredExams} paginator
                            rows={rows}
                            first={first}
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            rowsPerPageOptions={[5, 10, 20]}
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            onPage={onPageChange}
                            className='custom-table'
                            scrollHeight='calc(100vh - 175px)'
                            size='small'
                        >
                            <Column header="Sr No" body={srNoBodyTemplate} style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                            <Column field="ClassName" header="Class" style={{ minWidth: '8rem', maxWidth: '8rem' }} />
                            <Column field="TermName" header="Term Name" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                            <Column field="CoScholasticName" header="Co-Scholastic Name" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                            <Column header='Action' body={actionTemplate} headerStyle={{ display: 'flex', justifyContent: 'end' }} />
                        </DataTable>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default CoScholasticGrading;
